<!-- 缺陷reopen -->
<template>
  <div>
    <a-card title="需求状态分布" size="small">
      <div id="dev-chart" :style="{ height: height, width: width }" />
    </a-card>
    <a-modal :visible="modalVisible" :title="title" :closable="false" :width="800" @cancel="closeModal">
      <a-table :columns="columns" :data-source="tableData" :width="700">
        <span slot="name" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.name">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.name }}</a>
          </a-tooltip>
        </span>
        <span slot="level" slot-scope="text, record">{{ record.level || '--' }}</span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>
<script>
// import { getVersionReqStatus } from '@api/data/quality';
import { getVersionReqStatus } from '@/api/data/quality';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '250px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      myChart: null,
      modalVisible: false,
      title: '',
      tableData: [],
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '需求名',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '优先级',
          dataIndex: 'level',
          key: 'level',
          scopedSlots: { customRender: 'level' }
        }
      ],
      option: {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {},
        series: [
          {
            name: null,
            type: 'pie',
            radius: '60%',
            center: ['50%', '58%'],
            data: [],
            label: {
              formatter: params => {
                return params.name + ': ' + params.value + ' (' + params.percent.toFixed(1) + '%)';
              }
            },
            itemStyle: {
              borderRadius: 6,
              borderColor: '#fff',
              borderWidth: 2
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: 'bold'
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    link() {
      return record => {
        return this.$router.resolve({ name: 'page:project:story:detail', params: { project_id: record.project }, query: { storyId: record.id }}).href;
      };
    }
  },
  watch: {
    filterForm() {
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/pie'); // 饼图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    this.myChart = echarts.init(document.getElementById('dev-chart'));
    this.myChart.on('click', params => {
      this.tableData = params.data.detail;
      this.modalVisible = true;
      this.title = params.data.name;
    });
    setTimeout(() => {
      this.getDiagramData();
    }, 100); // 添加延迟
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    closeModal() {
      this.modalVisible = false;
    },
    getDiagramData() {
      this.loading = true;
      getVersionReqStatus(this.filterForm).then(res => {
        this.option.series[0].data = [
          {
            value: res.data.done.length,
            name: '开发完成',
            detail: res.data.done
          },
          {
            value: res.data.not_deved.length,
            name: '未开发完成',
            detail: res.data.not_deved
          },
          {
            value: res.data.online.length,
            name: '已上线',
            detail: res.data.online
          },
          {
            value: res.data.under_demo.length,
            name: 'demo验收中',
            detail: res.data.under_demo
          },
          {
            value: res.data.under_qa.length,
            name: '质量验收中',
            detail: res.data.under_qa
          }
        ];
        this.drawChart();
      }).catch(() => {
        this.loading = false;
      });
    }
  }
};
</script>
